import { AlertCircleIcon } from "lucide-react";
import React, { Component, ErrorInfo, ReactNode } from "react";

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    public static getDerivedStateFromError(): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    public render() {
        const { children } = this.props;
        const { hasError } = this.state;

        if (hasError) {
            return (
                <main className="w-full h-screen flex flex-col gap-2 justify-center items-center">
                    <AlertCircleIcon className="w-16 h-16 text-red-400" />
                    <h1 className="text-2xl font-semibold">
                        Something went wrong.
                    </h1>
                    <p className="text-sm">
                        Click Reload but if it persists contact te Dev Team.
                    </p>
                    <button
                        type="button"
                        className="mt-6 bg-red-500 hover:bg-red-600 text-red-50 rounded-md px-8 py-2 w-full max-w-xs"
                        onClick={() => window.location.reload()}
                    >
                        Click to Reload
                    </button>
                </main>
            );
        }

        return children;
    }
}

export default ErrorBoundary;
